import React, { useState } from "react";

function ContactModal({ onClose, defaultSubject, defaultMessage, userName, userEmail }) {
  const [form, setForm] = useState({ name: userName||'', email: userEmail||'', subject: defaultSubject||'', message: defaultMessage||'' });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSend = async () => {
    if (!form.email || !form.message) { setError('Please provide your email and message.'); return; }
    setSending(true); setError('');
    try {
      const resp = await fetch('/api/send-contact', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      if (resp.ok) { setSent(true); }
      else { setError('Failed to send. Please try again or email support@southjerseyvendormarket.com directly.'); }
    } catch { setError('Failed to send. Please try again or email support@southjerseyvendormarket.com directly.'); }
    setSending(false);
  };

  return (
    <div onClick={onClose} style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.6)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:16}}>
      <div onClick={e=>e.stopPropagation()} style={{background:'#fff',borderRadius:16,maxWidth:480,width:'100%',overflow:'hidden'}}>
        <div style={{background:'#1a1410',padding:'24px 28px',textAlign:'center'}}>
          <div style={{fontSize:20,fontWeight:700,color:'#e8c97a',fontFamily:'Playfair Display,serif'}}>Contact Us</div>
          <div style={{fontSize:13,color:'#a89a8a',marginTop:4}}>We typically respond within 24 hours</div>
        </div>
        <div style={{padding:'24px 28px'}}>
          {sent ? (
            <div style={{textAlign:'center',padding:'20px 0'}}>
              <div style={{fontSize:32,marginBottom:8}}>{'\u2713'}</div>
              <div style={{fontSize:16,fontWeight:700,color:'#1a6b3a',marginBottom:8}}>Thanks for reaching out!</div>
              <div style={{fontSize:14,color:'#7a6a5a',marginBottom:20}}>We typically respond within 24 hours.</div>
              <button onClick={onClose} style={{background:'#1a1410',color:'#e8c97a',border:'none',borderRadius:8,padding:'10px 24px',fontSize:14,fontWeight:600,cursor:'pointer',fontFamily:'DM Sans,sans-serif'}}>Close</button>
            </div>
          ) : (
            <>
              <div className="form-group" style={{marginBottom:10}}><label>Name</label><input value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))} placeholder="Your name" /></div>
              <div className="form-group" style={{marginBottom:10}}><label>Email <span style={{color:'#c0392b'}}>*</span></label><input type="email" value={form.email} onChange={e=>setForm(f=>({...f,email:e.target.value}))} placeholder="you@email.com" /></div>
              <div className="form-group" style={{marginBottom:10}}><label>Subject</label><input value={form.subject} onChange={e=>setForm(f=>({...f,subject:e.target.value}))} placeholder="What's this about?" /></div>
              <div className="form-group" style={{marginBottom:14}}><label>Message <span style={{color:'#c0392b'}}>*</span></label><textarea value={form.message} onChange={e=>setForm(f=>({...f,message:e.target.value}))} placeholder="How can we help?" style={{minHeight:100,resize:'vertical'}} /></div>
              {error && <div style={{color:'#c0392b',fontSize:13,marginBottom:12,background:'#fdecea',border:'1px solid #f5c6c6',borderRadius:8,padding:'8px 12px'}}>{error}</div>}
              <button onClick={handleSend} disabled={sending} style={{width:'100%',background:'#c8a84b',color:'#1a1410',border:'none',borderRadius:8,padding:'12px 0',fontSize:15,fontWeight:700,cursor:'pointer',fontFamily:'DM Sans,sans-serif',opacity:sending?0.6:1}}>
                {sending ? 'Sending...' : 'Send Message'}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ContactModal;
